<template>
  <card v-loading="loading">
    <h4 class="card-title">{{ $t('Notifications') }}</h4>
      <div slot="default">
        <ul class="notifications">
          <li v-for="notification in data" :key="notification.notice_type">
            <span class="notification-description">{{ $t(notification.notice_descr) }}</span>
            <span v-if="notification.have_param" class="notification-param">
              <el-input-number :disabled="!notification.is_sms && !notification.is_email" @keypress.native="onlyNumber" v-model="notification.param_value" size="mini"></el-input-number>
            </span>
            <span class="switchers">
              <el-switch v-if="notification.hasOwnProperty('is_email')" v-model="notification.is_email" active-text="Email" class="notification-subscribe"></el-switch>
              <el-switch v-if="notification.hasOwnProperty('is_sms')" v-model="notification.is_sms" active-text="SMS" class="notification-subscribe"></el-switch>
            </span>
          </li>
        </ul>
        <el-button type="primary" size="medium" @click="updateNotifications">{{ $t('Save') }}</el-button>
      </div>
  </card>

</template>

<script>
import { Input, InputNumber, Switch, Button } from 'element-ui'

export default {
  name: 'Notifications',
  components: {
    'el-input-number': InputNumber,
    'el-switch': Switch,
    'el-button': Button,
    'el-input': Input
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  methods: {
    onlyNumber: function(event) {
      event = event || window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault()
      } else {
        return true
      }
    },
    updateNotifications: function() {
      this.$emit('updateNotifications')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-title {
  margin-bottom: 30px !important;
}
.notifications {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-bottom: 20px;
  & > li {
    padding: 15px 0;
    display: flex;
    align-items: center;
    @media (max-width: 767px) {
      padding: 20px 0;
      flex-direction: column;
      align-items: start;
      & > *:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
  .notification-param {
    margin-right: 20px;
  }
  .notification-description {
    margin-right: auto;
  }

  .switchers {
    display: flex;
    & > *:not(:last-child) {
      margin-right: 20px;
    }
    @media (min-width: 768px) {
      width: 200px;
    }
  }

}
</style>
